import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';


function Page(props) {
  if (props.hidden) return;
  const pageLink = `${props.base_url}/${props.page}`;
  const linkText = props.text ? props.text : props.page;
  const klass = props.active ? 'active' : '';

  return (
    <li className={klass}><Link to={pageLink}>{linkText}</Link></li>
  )
}

Page.propTypes = {
  base_url: PropTypes.string.isRequired,
  text: PropTypes.string,
  active: PropTypes.bool,
  page: PropTypes.number.isRequired,
  hidden: PropTypes.bool
};


export class Pager extends Component {

  getPageRange() {
    let pageFrom, pageTo, left, right;
    const curPage = this.props.current;
    const totalPage = this.props.total;
    const displayNum = 5;

    left = (displayNum - 1) / 2;
    right = left + 1;

    if (curPage === 1 || curPage === 2) {
      pageFrom = 1;
      pageTo = (totalPage > displayNum) ? displayNum + 1 : totalPage + 1;
    } else if (curPage === totalPage - 1 || curPage === totalPage) {
      pageFrom = (totalPage > displayNum) ? totalPage - displayNum + 1: 1;
      pageTo = totalPage + 1;
    } else {
      pageFrom = curPage - left;
      pageTo = curPage + right;
    }
    return [pageFrom, pageTo];
  }

  render() {

    const pageRange = this.getPageRange();

    const PageNodes = range(...pageRange).map((el, i) => {
      const isActive = this.props.current === el;
      return <Page base_url={this.props.base_url}
                   page={el}
                   active={isActive} key={i}/>
    });

    return (
      <ul>
        <Page base_url={this.props.base_url}
              text={'<<'}
              page={1} />
        {PageNodes}
        <Page base_url={this.props.base_url}
              text={'>>'}
              page={this.props.total} />
      </ul>
    )
  }
}

Pager.propTypes = {
  current:               PropTypes.number.isRequired,
  total:                 PropTypes.number.isRequired,
  base_url:              PropTypes.string.isRequired,
};

function range ( start, end ) {
  let res = [];
  for ( let i = start; i < end; i++ ) {
    res.push( i );
  }
  return res;
}


// WEBPACK FOOTER //
// ./src/components/parts/Pager.jsx